import { FormBuilder, Validators } from '@angular/forms';

export const addContactUsForm = () =>
  FormBuilder.prototype.group({
    name: [null, [Validators.required, Validators.maxLength(50)]],
    subject: [null, [Validators.required, Validators.maxLength(50)]],
    email: [null, [Validators.required, Validators.email]],
    phoneNumber: [null, [Validators.required]],
    details: [null, [Validators.required]],
  });

export const contactUsValidationMessages = {
  name: {
    required: 'Name is required.',
    maxLength: 'Name must not exceed 50 characters.',
  },
  subject: {
    required: 'Subject is required.',
    maxLength: 'Subject must not exceed 50 characters.',
  },
  email: {
    required: 'Email is required.',
    email: 'Email is invalid'
  },
  phoneNumber: {
    required: 'Phone number is required.',
  },
  details: {
    required: 'Details are required.',
  },
};
